// src-lit/components/product/kd-variant-spec.ts
import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { onEvent } from '../../utils/dom';
import { EVENT_NAMES, type VariantSelectedDetail } from '../../constants/events';
import { SELECTORS } from '../../constants/selectors';
import { safeJsonParse } from '../../utils/data';

/** variantId → spec ラベル（例: "350ml×72缶"）。空文字はバッジ hidden。 */
type SpecMap = Record<string, string>;

/**
 * @element kd-variant-spec
 * @description バリアント選択に応じて 内容量×商品セット の spec ラベルを更新する軽量要素。
 *   画像スライダー左下の spec バッジ（mock 20260707）に使う。option1（商品セット）が
 *   variant 依存のため、kd-product-variant-selected を購読して textContent / hidden を更新する。
 *   商品セット名の live 更新は H1 直下の内容量バッジ（kd-product-title）と同思想。
 */
@customElement('kd-variant-spec')
export class KdVariantSpec extends LitElement {
  createRenderRoot() {
    return this;
  }

  private unsubscribe: (() => void) | null = null;

  private specMap: SpecMap = {};

  render() {
    return nothing;
  }

  connectedCallback(): void {
    super.connectedCallback();
    const script = this.querySelector<HTMLScriptElement>(
      SELECTORS.VARIANT_SPEC.SPEC_MAP,
    );
    this.specMap = safeJsonParse<SpecMap>(script?.textContent, {});
    this.unsubscribe = onEvent<VariantSelectedDetail>(
      document,
      EVENT_NAMES.PRODUCT.VARIANT_SELECTED,
      (e) => this.handleVariantSelected(e.detail),
    );
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.unsubscribe?.();
    this.unsubscribe = null;
  }

  private handleVariantSelected(detail: VariantSelectedDetail): void {
    const badge = this.querySelector<HTMLElement>(SELECTORS.VARIANT_SPEC.BADGE);
    if (!badge) return;

    const label = this.specMap[detail.variantId];
    if (label === undefined) return;

    if (label === '') {
      badge.hidden = true;
      return;
    }
    badge.hidden = false;
    badge.textContent = label;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-variant-spec': KdVariantSpec;
  }
}
